import React, {FC, ReactElement} from 'react';
import { Navigate, Route, useLocation, useRoutes} from 'react-router-dom';

 // import MUI.
 
 // import library.

 // import user Component
 // ... CRM ...
 import {BankRoleForm, BankPersonForm, BankPersonListForm,
    BankUserForm, BankPolicyForm,BankPolicyListForm, BankAgency, BankGroupPolicyForm,
    BankUserChangePwdForm} from './crm';

import Home from '../layout/Home';

import {defaultBankPolicy} from './crm'; 
    
 // import user Library.
 import {useUserStore} from '../library/store';
import { defaultPasswordChange } from './crm/model/BankUser';



interface Props  {
    element: React.ReactElement;
    path?: string;
}

const PrivateElement = ({element} : Props) : React.ReactElement => {
    let location = useLocation();
    

    const {isAuthenticated} = useUserStore();
    // console.log(location);
    // console.log(isAuthenticated);

    return isAuthenticated ? element : <Navigate to="/login" state={{ from: location }} />
}

const PrivateRoute : FC<Props> = ({element, ...rest}) => {
    //console.log(rest);
    // const {location } = useLocation();
    // console.log(location);

    return <Route {...rest} element={<PrivateElement element={element} />} />;
}

export default PrivateRoute;

// var userTestStatus: Array<{ path: string, element: ReactElement }> = Array(
//     { "id": 0, "name": "Available" },
//     { "id": 1, "name": "Ready" },
//     { "id": 2, "name": "Started" }
// );

export const routes : Array<{ path: string, element: ReactElement, exact: boolean }> = [

    { path:'/bankRole',  element: <Home /> ,   exact: true  },
    //{ path:'/bankRoleList',  element: <BankRoleListForm  /> ,   exact: true  },
    
    { path:'/bankUser',  element: <BankUserForm password='DEFAULT_PASSWORD' roles={[]} groupPolicies={[]} agencies={[]} /> ,   exact: true  },
    { path:'/bankPolicy',  element: <BankPolicyForm {...defaultBankPolicy} /> ,   exact: true  },
    { path:'/bankPerson/:bankPersonID',  element: <BankPersonForm  /> ,   exact: false  },
    { path:'/bankPersonList',  element: <BankPersonListForm  /> ,   exact: true  },
    { path:'/bankAgency',  element: <BankAgency /> ,   exact: true  },
    { path:'/bankGroupPolicy',  element: <BankGroupPolicyForm groupPolicyID={0} contractNumber='' lineOfBusinessCode='' /> ,   exact: true  },
];


export const AppRoutes = () => {
    let routes = useRoutes([
        { path:'/',  element: <Home />,
            children:[{path: ':count', element: <Home /> }]},
        {path: '/bankRole', element: <BankRoleForm roleItems={[]} />,
            children:[{path: ':roleID', element: <BankRoleForm roleItems={[]} /> }]  },
        { path:'/bankUser',  element: <BankUserForm password='DEFAULT_PASSWORD' roles={[]} groupPolicies={[]} agencies={[]} />,
            children:[{path: ':userID', element: <BankUserForm password='DEFAULT_PASSWORD'roles={[]} groupPolicies={[]} agencies={[]} /> }]  },
        { path:'/bankPolicy',  element: <BankPolicyForm {...defaultBankPolicy} />,
            children:[{path: ':policyID', element: <BankPolicyForm {...defaultBankPolicy} /> }]  },
        { path:'/bankPolicyList',  element: <BankPolicyListForm  />   },
        { path:'/bankPerson',  element: <BankPersonForm  /> ,
            children:[{path: ':bankPersonID', element: <BankPersonForm /> }]  },
        { path:'/bankPersonList',  element: <BankPersonListForm  />   },
        { path:'/changePassword',  element: <BankUserChangePwdForm {...defaultPasswordChange}  />   },
        
        { path:'/bankAgency',  element: <BankAgency />   },
        { path:'/bankGroupPolicy',  element: <BankGroupPolicyForm groupPolicyID={0} contractNumber='' lineOfBusinessCode='' />,
            children:[{path: ':groupPolicyID', element: <BankGroupPolicyForm groupPolicyID={0} contractNumber='' lineOfBusinessCode='' /> }] },
    ]);

    return routes;
} 